import React, { useEffect, useState } from "react";

import { BiBell } from "react-icons/bi";

import { useAppState } from "../../../context/StateContext";
import { useNotificationHook } from "../../../hooks/useNotificationActions";
import NotificationsListDropdown from "./NotificationsListDropdown";
import useStyles, {
  NotificationMenuIcon,
  NotificationsBadgeCount,
  NotificationsMenu,
} from "./styles";

interface NotificationBlockProps {
  handleGoToNotificationsScreen: () => void;
  handleSelected: () => void;
}

const NotificationBlock = ({
  handleGoToNotificationsScreen,
  handleSelected,
}: NotificationBlockProps) => {
  const classes = useStyles();
  const { unreadTotal } = useAppState();
  const { refetchUnreadNotificationsCount } = useNotificationHook();

  const [notificationDropdownMenu, setNotificationDropdownMenu] = useState<null | HTMLElement>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setNotificationDropdownMenu(event.currentTarget);
  };

  const handleClose = () => {
    setNotificationDropdownMenu(null);
  };

  useEffect(() => {
    refetchUnreadNotificationsCount();
  }, [refetchUnreadNotificationsCount]);

  const renderBellIcon = () =>
    unreadTotal ? (
      <NotificationsBadgeCount badgeContent={unreadTotal}>
        <BiBell color="#308CDB" size={20} />
      </NotificationsBadgeCount>
    ) : (
      <BiBell color="#308CDB" size={20} />
    );

  return (
    <div data-cy="userNotificationsMenu">
      <NotificationMenuIcon onClick={handleClick} isOpen={!!notificationDropdownMenu}>
        {renderBellIcon()}
      </NotificationMenuIcon>
      <NotificationsMenu
        anchorEl={notificationDropdownMenu}
        keepMounted={false}
        open={Boolean(notificationDropdownMenu)}
        onClose={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        PaperProps={{
          className: classes.menuPaper,
        }}
      >
        <NotificationsListDropdown
          handleGoToNotificationsScreen={handleGoToNotificationsScreen}
          handleSelected={handleSelected}
          handleClose={handleClose}
        />
      </NotificationsMenu>
    </div>
  );
};

export default NotificationBlock;
